import {atom} from 'jotai'
import {atomWithStorage} from 'jotai/utils'
import moment from 'moment'
import {createMigrationStorage} from '../migration-storage'

const AUTH_STORAGE_KEY = 'oauthCredentials'

// Server-side function for getting OAuth credentials from context (for SSR compatibility)
export function getOauthCredentialsServerSideCookieFromContext(ctx) {
  return null
}

export const oauthCredentialsState = atomWithStorage(
  AUTH_STORAGE_KEY,
  {
    accessToken: null,
    refreshToken: null,
    expiresAt: null
  },
  createMigrationStorage(AUTH_STORAGE_KEY),
  {getOnInit: true}
)

export const isAuthenticatedState = atom((get) => {
  const oauthCredentials = get(oauthCredentialsState)
  return !!oauthCredentials.accessToken
})

export const isValidlyAuthenticatedState = atom((get) => {
  const oauthCredentials = get(oauthCredentialsState)

  if (!oauthCredentials.accessToken) {
    return false
  }

  if (!oauthCredentials.expiresAt) {
    console.warn('[OAuth] Token exists but no expiry time - treating as valid')
    return true
  }

  const tokenExpiresAt = moment.utc(oauthCredentials.expiresAt)
  const now = moment.utc()
  const isExpired = tokenExpiresAt.isBefore(now)

  if (isExpired) {
    console.debug('[OAuth] Token is expired - treating as not authenticated')
    console.debug(`[OAuth] Token expired at: ${tokenExpiresAt.format()}, current time: ${now.format()}`)
  }

  return !isExpired
})
